import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth";
import { audiobookReducer } from "./audiobook";

const rootReducer = combineReducers({
  auth: authReducer,
  audiobook: audiobookReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type GlobalState = ReturnType<typeof store.getState>;

export default store;
